var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadless(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#000000",
    d: "M 120.5,7.5 C 242.5,7.33333 364.5,7.5 486.5,8C 494.667,10.8333 500.167,16.3333 503,24.5C 503.994,136.889 503.661,249.223 502,361.5C 498.686,368.149 493.519,372.649 486.5,375C 444.168,375.5 401.835,375.667 359.5,375.5C 362.124,396.425 354.124,411.591 335.5,421C 333.212,421.822 330.878,422.489 328.5,423C 300.161,423.167 271.827,423.667 243.5,424.5C 247.241,434.723 250.574,445.056 253.5,455.5C 264.505,455.333 275.505,455.5 286.5,456C 294.667,458.833 300.167,464.333 303,472.5C 303.5,482.828 303.666,493.161 303.5,503.5C 223.5,503.5 143.5,503.5 63.5,503.5C 63.3335,493.161 63.5002,482.828 64,472.5C 66.8333,464.333 72.3333,458.833 80.5,456C 91.495,455.5 102.495,455.333 113.5,455.5C 116.426,445.056 119.759,434.723 123.5,424.5C 93.7911,423.969 64.1244,423.135 34.5,422C 20.3937,416.894 11.5604,407.061 8,392.5C 7.33333,322.5 7.33333,252.5 8,182.5C 11.5604,167.939 20.3937,158.106 34.5,153C 57.4474,151.542 80.4474,151.042 103.5,151.5C 103.333,109.165 103.5,66.832 104,24.5C 107.019,16.3156 112.519,10.649 120.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3dc7e",
    d: "M 124.5,23.5 C 243.834,23.3333 363.167,23.5 482.5,24C 484.667,24.8333 486.167,26.3333 487,28.5C 487.5,42.8295 487.667,57.1628 487.5,71.5C 364.833,71.5 242.167,71.5 119.5,71.5C 119.333,57.1628 119.5,42.8295 120,28.5C 121.025,26.313 122.525,24.6464 124.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 135.5,39.5 C 140.833,39.5 146.167,39.5 151.5,39.5C 151.5,44.8333 151.5,50.1667 151.5,55.5C 146.167,55.5 140.833,55.5 135.5,55.5C 135.5,50.1667 135.5,44.8333 135.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 167.5,39.5 C 172.833,39.5 178.167,39.5 183.5,39.5C 183.5,44.8333 183.5,50.1667 183.5,55.5C 178.167,55.5 172.833,55.5 167.5,55.5C 167.5,50.1667 167.5,44.8333 167.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 199.5,39.5 C 204.833,39.5 210.167,39.5 215.5,39.5C 215.5,44.8333 215.5,50.1667 215.5,55.5C 210.167,55.5 204.833,55.5 199.5,55.5C 199.5,50.1667 199.5,44.8333 199.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e8ec",
    d: "M 119.5,87.5 C 242.167,87.5 364.833,87.5 487.5,87.5C 487.667,176.501 487.5,265.501 487,354.5C 486.167,356.667 484.667,358.167 482.5,359C 441.501,359.5 400.501,359.667 359.5,359.5C 359.5,354.167 359.5,348.833 359.5,343.5C 396.833,343.5 434.167,343.5 471.5,343.5C 471.5,295.5 471.5,247.5 471.5,199.5C 434.167,199.5 396.833,199.5 359.5,199.5C 361.422,176.153 351.422,160.653 329.5,153C 259.537,151.516 189.537,151.016 119.5,151.5C 119.5,130.167 119.5,108.833 119.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 135.5,103.5 C 140.833,103.5 146.167,103.5 151.5,103.5C 151.5,108.833 151.5,114.167 151.5,119.5C 146.167,119.5 140.833,119.5 135.5,119.5C 135.5,114.167 135.5,108.833 135.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 167.5,103.5 C 268.833,103.5 370.167,103.5 471.5,103.5C 471.5,108.833 471.5,114.167 471.5,119.5C 370.167,119.5 268.833,119.5 167.5,119.5C 167.5,114.167 167.5,108.833 167.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 375.5,135.5 C 407.5,135.5 439.5,135.5 471.5,135.5C 471.5,140.833 471.5,146.167 471.5,151.5C 439.5,151.5 407.5,151.5 375.5,151.5C 375.5,146.167 375.5,140.833 375.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68d5f3",
    d: "M 41.5,167.5 C 135.834,167.333 230.167,167.5 324.5,168C 333.573,170.739 339.74,176.573 343,185.5C 343.5,238.166 343.667,290.832 343.5,343.5C 236.833,343.5 130.167,343.5 23.5,343.5C 23.3333,290.832 23.5,238.166 24,185.5C 27.3531,176.982 33.1865,170.982 41.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 375.5,167.5 C 407.5,167.5 439.5,167.5 471.5,167.5C 471.5,172.833 471.5,178.167 471.5,183.5C 439.5,183.5 407.5,183.5 375.5,183.5C 375.5,178.167 375.5,172.833 375.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 57.5,183.5 C 114.501,183.333 171.501,183.5 228.5,184C 237.598,186.766 243.765,192.599 247,201.5C 247.667,237.167 247.667,272.833 247,308.5C 244.058,318.443 237.558,324.609 227.5,327C 170.833,327.667 114.167,327.667 57.5,327C 48.5992,323.765 42.7659,317.598 40,308.5C 39.3333,272.833 39.3333,237.167 40,201.5C 43.3531,192.982 49.1865,186.982 57.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 263.5,183.5 C 284.833,183.5 306.167,183.5 327.5,183.5C 327.5,188.833 327.5,194.167 327.5,199.5C 306.167,199.5 284.833,199.5 263.5,199.5C 263.5,194.167 263.5,188.833 263.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fad56f",
    d: "M 60.5,199.5 C 116.584,199.008 172.584,199.508 228.5,201C 229.701,201.903 230.535,203.069 231,204.5C 231.986,239.252 231.653,273.918 230,308.5C 229.097,309.701 227.931,310.535 226.5,311C 170.417,311.991 114.417,311.658 58.5,310C 57.2986,309.097 56.4652,307.931 56,306.5C 55.3333,272.5 55.3333,238.5 56,204.5C 57.025,202.313 58.525,200.646 60.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030301",
    d: "M 151.5,205.5 C 157.044,206.068 162.044,207.901 166.5,211C 155.858,242.425 145.525,273.925 135.5,305.5C 130.5,304.167 125.5,302.833 120.5,301.5C 130.428,269.383 140.761,237.383 151.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 263.5,215.5 C 284.833,215.5 306.167,215.5 327.5,215.5C 327.5,220.833 327.5,226.167 327.5,231.5C 306.167,231.5 284.833,231.5 263.5,231.5C 263.5,226.167 263.5,220.833 263.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe826d",
    d: "M 359.5,215.5 C 391.5,215.5 423.5,215.5 455.5,215.5C 455.5,252.833 455.5,290.167 455.5,327.5C 423.5,327.5 391.5,327.5 359.5,327.5C 359.5,290.167 359.5,252.833 359.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#080603",
    d: "M 104.5,218.5 C 109.085,221.414 113.085,225.08 116.5,229.5C 108.167,238.167 99.8333,246.833 91.5,255.5C 99.8333,264.167 108.167,272.833 116.5,281.5C 113.167,285.5 109.5,289.167 105.5,292.5C 92.8333,280.5 80.5,268.167 68.5,255.5C 80.5213,243.146 92.5213,230.813 104.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#080603",
    d: "M 180.5,218.5 C 193.761,230.092 206.427,242.426 218.5,255.5C 206.5,268.167 194.167,280.5 181.5,292.5C 177.5,289.167 173.833,285.5 170.5,281.5C 178.833,272.833 187.167,264.167 195.5,255.5C 187.167,246.833 178.833,238.167 170.5,229.5C 173.855,225.813 177.189,222.147 180.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 263.5,247.5 C 284.833,247.5 306.167,247.5 327.5,247.5C 327.5,252.833 327.5,258.167 327.5,263.5C 306.167,263.5 284.833,263.5 263.5,263.5C 263.5,258.167 263.5,252.833 263.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 263.5,279.5 C 284.833,279.5 306.167,279.5 327.5,279.5C 327.5,284.833 327.5,290.167 327.5,295.5C 306.167,295.5 284.833,295.5 263.5,295.5C 263.5,290.167 263.5,284.833 263.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 279.5,311.5 C 284.833,311.5 290.167,311.5 295.5,311.5C 295.5,316.833 295.5,322.167 295.5,327.5C 290.167,327.5 284.833,327.5 279.5,327.5C 279.5,322.167 279.5,316.833 279.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 311.5,311.5 C 316.833,311.5 322.167,311.5 327.5,311.5C 327.5,316.833 327.5,322.167 327.5,327.5C 322.167,327.5 316.833,327.5 311.5,327.5C 311.5,322.167 311.5,316.833 311.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9b1bc",
    d: "M 23.5,359.5 C 130.167,359.5 236.833,359.5 343.5,359.5C 343.666,369.506 343.5,379.506 343,389.5C 339.74,398.427 333.573,404.261 324.5,407C 230.167,407.667 135.833,407.667 41.5,407C 33,403.833 27.1667,398 24,389.5C 23.5002,379.506 23.3335,369.506 23.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 143.5,375.5 C 148.833,375.5 154.167,375.5 159.5,375.5C 159.5,380.833 159.5,386.167 159.5,391.5C 154.167,391.5 148.833,391.5 143.5,391.5C 143.5,386.167 143.5,380.833 143.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 175.5,375.5 C 180.833,375.5 186.167,375.5 191.5,375.5C 191.5,380.833 191.5,386.167 191.5,391.5C 186.167,391.5 180.833,391.5 175.5,391.5C 175.5,386.167 175.5,380.833 175.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 207.5,375.5 C 212.833,375.5 218.167,375.5 223.5,375.5C 223.5,380.833 223.5,386.167 223.5,391.5C 218.167,391.5 212.833,391.5 207.5,391.5C 207.5,386.167 207.5,380.833 207.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#959ea9",
    d: "M 140.5,423.5 C 169.167,423.5 197.833,423.5 226.5,423.5C 229.426,433.944 232.759,444.277 236.5,454.5C 201.167,455.833 165.833,455.833 130.5,454.5C 134.241,444.277 137.574,433.944 140.5,423.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#959ea9",
    d: "M 84.5,471.5 C 150.501,471.333 216.501,471.5 282.5,472C 284.667,472.833 286.167,474.333 287,476.5C 287.499,480.152 287.665,483.818 287.5,487.5C 218.167,487.5 148.833,487.5 79.5,487.5C 79.3347,483.818 79.5014,480.152 80,476.5C 81.025,474.313 82.525,472.646 84.5,471.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadless);
export default __webpack_public_path__ + "static/media/headless.090643a0d2d9172fd6a4d1a3ee04e239.svg";
export { ForwardRef as ReactComponent };